exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-processing-modal {\n  .ant-modal-content {\n    border-radius: 20px;\n  }\n}\n", ""]);

// exports
